import React, { ReactNode, ReactNodeArray } from 'react'
import { StyledContainer } from './styled'
import { Scrollable } from '../Scrollable'

interface IDetailsTemplate {
  children: ReactNode | ReactNodeArray
  aside?: ReactNode
  contentProps?: any
  asideProps?: any
}

export const DetailsTemplate = ({
  children,
  aside,
  contentProps,
  asideProps,
}: IDetailsTemplate) => (
  <StyledContainer>
    <section {...contentProps}>
      <Scrollable>{children}</Scrollable>
    </section>
    {aside && (
      <aside {...asideProps}>
        <Scrollable>{aside}</Scrollable>
      </aside>
    )}
  </StyledContainer>
)
